export default "__VITE_ASSET__Cj4ruVlj__"